import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { i18n } from '@/i18n';
import TextButton from '@/components/input/Btn/TextButton.vue';
import { useUnmanagedBusinessStore } from '@/unmanagedBusinessModule/pages/unmanagedBusinessStore';
import { storeToRefs } from 'pinia';
import { TableContentItem } from '../../interface/tableContentItems';


export default /*@__PURE__*/_defineComponent({
  __name: 'RegisterUnmanagedBusinessButton',
  props: {
    item: {}
  },
  setup(__props: any) {

const t = i18n.t;

const store = useUnmanagedBusinessStore();
const { state } = storeToRefs(store);
const { setSelectedBusiness, openModal } = store;

const props = __props;

/**
 * ボタンクリック時の処理
 */
const onClick = () => {
  setSelectedBusiness(props.item);
  openModal('registerBusiness');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TextButton, { onClick: onClick }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('取引登録')), 1)
    ], undefined, true),
    _: 1
  }))
}
}

})